import { useContext } from "react";
import Message from "../../../../i18n/Message";
import "./ToolsSection.scss";
import ToolItem from "./ToolItem";
import { useUiMode } from "../context/UiModeContext";
import { ManageContext } from "../context/ManageContext";
import UpgradeHint from "../../../shared/subscription/UpgradeHint";

const ToolsSection = ({ playground }) => {
  const tools = JSON.parse(playground.toolsJson);
  const { uiMode } = useUiMode();
  // `toolLimit` is only provided in the admin preview (manage mode). Public/embed viewers already
  // receive a backend-capped tool list, so they never see the overflow hint.
  const { manage, toolLimit } = useContext(ManageContext);
  const hasOverflow =
    manage && toolLimit != null && tools.length > toolLimit;

  return (
    <div className={`tools_section ${uiMode.toLowerCase()}_mode`}>
      <h2>
        <Message id="widget_tools_title" />
      </h2>
      {hasOverflow && (
        <div className="tools_overflow_hint">
          <span>
            <Message
              id="tools_limit_hint"
              values={{ active: toolLimit, total: tools.length }}
            />
          </span>
          <UpgradeHint messageId="upgrade" plan="pro" />
        </div>
      )}
      <div className="tools_list">
        {tools.map((tool, index) => (
          <ToolItem
            key={tool.name}
            tool={tool}
            locked={hasOverflow && index >= toolLimit}
          />
        ))}
      </div>
    </div>
  );
};

export default ToolsSection;
